"use client";

import { usePathname } from "next/navigation";
import { useEffect, useRef } from "react";

type OnRouteChangeCallback = (
  previousPath: string | null, // null on the very first mount
  currentPath: string, // full pathname, e.g. "/a/c/accounts"
) => void;

export function useOnRouteChange(callback: OnRouteChangeCallback) {
  const pathname = usePathname();
  const previousPathRef = useRef<string | null>(null);

  useEffect(
    function handleRouteChange() {
      const previous = previousPathRef.current;
      previousPathRef.current = pathname;

      callback(previous, pathname);
    },
    [callback, pathname],
  );
}
